const tocItems = [
  { label: 'Why Choose MrCuci?', href: '#why-choose-ausclub' },
  { label: 'Exclusive Bonuses & Promotions', href: '#exclusive-bonuses-promotions' },
  { label: 'Explore Our Game Categories', href: '#explore-game-categories' },
  { label: 'Why Trust MrCuci?', href: '#why-trust-ausclub' },
  { label: 'MrCuci In-Depth Review', href: '#seo-blog-section' },
  { label: 'Responsible Gambling Commitment', href: '#responsible-gambling-commitment' },
  { label: 'What Our Players Say', href: '#what-our-players-say' },
  { label: 'Frequently Asked Questions', href: '#frequently-asked-questions' },
];

export default function TableOfContents() {
  return (
    <section
      className="border-y border-[#d4a017]/15"
      style={{ background: 'linear-gradient(135deg, #0d0101 0%, #130202 100%)' }}
    >
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-1 h-8 bg-gradient-to-b from-[#cc1100] to-[#d4a017] rounded-full" />
          <h2 className="text-white text-xl font-bold">Table of Contents</h2>
        </div>
        <ul className="grid sm:grid-cols-2 gap-1">
          {tocItems.map((item, idx) => (
            <li key={item.href}>
              <a
                href={item.href}
                className="flex items-center gap-3 text-gray-400 hover:text-[#d4a017] transition-colors duration-200 text-sm py-2.5 px-3 rounded-lg hover:bg-[#d4a017]/5 cursor-pointer group border border-transparent hover:border-[#d4a017]/15"
              >
                <span
                  className="shrink-0 w-6 h-6 flex items-center justify-center rounded-md text-xs font-bold"
                  style={{ background: 'linear-gradient(135deg, #cc1100, #d4a017)', color: 'black' }}
                >
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <span className="group-hover:underline">{item.label}</span>
                <span className="w-4 h-4 flex items-center justify-center ml-auto opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-arrow-right-s-line text-[#d4a017]" />
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
